import * as React from 'react'
import { TaskToolList } from './TaskToolList'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_TASK_A_ID } from 'mockState'

export const TaskToolListExamples = () => {
  return (
    <div className="TaskToolListExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskToolList taskId={MOCK_TASK_A_ID} />
      </Provider>
    </div>
  )
}
